import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonToolbar } from '@ionic/react';


import { Geolocation } from '@capacitor/geolocation';
import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

import '../../css/layout.css';

export function Registration_GeoLocation (props) {


let authMerchant_objects = useContext(Auth_Zasava_Context);

const [distance_miles, setDistance_miles] = useState(null);


async function getCurrentLocation() {
    try{

        let position = await Geolocation.getCurrentPosition();

        props.gps_location([position.coords.latitude, position.coords.longitude]);

    }
    catch(error)
    {
        console.error('Error getting location:', error);
    }
}

useEffect(() => {


     getCurrentLocation();

   }, [])

return (
    <React.Fragment>
        <IonRow>
            <IonCol>
                {/*{coordinates != null && <IonText>Latitude: {coordinates.latitude}, Longitude {coordinates.longitude}</IonText>}*/}

                {distance_miles != null && <IonText  style={{ fontSize: '.8rem' }}>{distance_miles.toFixed(2)} miles away</IonText>}
                    
                {/*{coordinates == null &&  <IonText>Loading location...</IonText>}*/}
          </IonCol>
        </IonRow>
    </React.Fragment>)
}